import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { FileText, Shield, Zap } from 'lucide-react';

export const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const features = [
    {
      icon: FileText,
      title: 'Document Management',
      description: 'Upload, organize, and manage legal documents with ease',
    },
    {
      icon: Zap,
      title: 'AI-Powered Analysis',
      description: 'Get instant insights with Claude-powered document analysis',
    },
    {
      icon: Shield,
      title: 'Enterprise Security',
      description: 'Bank-grade security with Auth0 authentication',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-900 via-dark-800 to-dark-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-600 rounded-full mb-4">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Contract Management
          </h1>
          <p className="text-gray-400">
            AI-powered legal document management system
          </p>
        </div>

        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Welcome</h2>
            <p className="card-description">
              Sign in to access your contract management dashboard
            </p>
          </div>

          <div className="space-y-4 mb-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <Icon className="w-5 h-5 text-primary-500 mt-0.5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                      {feature.title}
                    </h3>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      {feature.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            onClick={() => loginWithRedirect()}
            className="w-full btn-primary"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}; 